// extracted by mini-css-extract-plugin
export default {"root":"ProductList_root__kbCmB","header":"ProductList_header__eFla+","searchInput":"ProductList_searchInput__2bfP9","headerButtons":"ProductList_headerButtons__V01aE"};